/* eslint-disable react/forbid-component-props */
import { faShoppingBasket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { EMPTY_BASKET } from '../../brands/default/content/components/checkout';
import { LINK_HOME, LINK_LOGIN } from '../../brands/default/links';
import { trackEvent, trackSecurePage } from '../../helpers/analytics';
import ThemeContext from '../../providers/ThemeProvider';
import CTAButton from '../_generic/button/CTAButton';

export default function EmptyBasket({ isAuthenticated }) {
  const theme = useContext(ThemeContext);

  useEffect(() => {
    trackSecurePage({
      dealData: [],
      dealId: [],
      events: ',sccheckout,scview',
      numProducts: 0,
      orderValue: 0,
      pageName: 'checkout',
      products: '',
    });
  }, []);

  return (
    <>
      <div className="empty-basket">
        <FontAwesomeIcon
          color={theme.colors.primary}
          icon={faShoppingBasket}
          style={{ height: 60, width: 60 }}
        />
        <p>
          <b>{EMPTY_BASKET.yourBasketIsEmpty}</b>
        </p>

        <p>
          {isAuthenticated ? (
            <>{EMPTY_BASKET.browseGreatDealsAnd}</>
          ) : (
            <>
              {EMPTY_BASKET.browseGreatDealsOr}{' '}
              <Link href={LINK_LOGIN} passHref>
                <>
                  <a className="empty-basket__link" href={LINK_LOGIN}>
                    {EMPTY_BASKET.login}
                  </a>{' '}
                  {EMPTY_BASKET.toSeeSavedItems}
                </>
              </Link>
            </>
          )}
        </p>

        <Link href={LINK_HOME}>
          <a>
            <CTAButton
              ariaLabel={EMPTY_BASKET.continueShopping}
              onClick={() => {
                trackEvent('cart_continue_shopping');
              }}
              style={{ textTransform: theme.text.cta.button }}
            >
              {EMPTY_BASKET.continueShopping}
            </CTAButton>
          </a>
        </Link>
      </div>
      <style jsx>{`
        .empty-basket {
          width: 250px;
          margin: 0 auto;
          text-align: center;
          padding: 15px;
        }
        .empty-basket__link {
          color: ${theme.colors.checkoutloginlink};
          font-weight: bold;
          font-style: italic;
          text-decoration: underline;
        }
        .empty-basket__link:hover {
          color: ${theme.colors.checkoutloginlinkactive};
        }
      `}</style>
    </>
  );
}

EmptyBasket.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};
